<template>
	<div>
		<p v-if="userNotFound" class="error-message type--serif">{{ userNotFoundMessage }}</p>

		<FormInput
			name="email"
			type="email"
			label="Email"
			:small="true"
			:compact="true"
			:hasError="$v.email.$error"
			:errorMessage="emailError"
			v-model="email"
		/>

		<div class="form-group is-small is-compact" :class="{'has-error' : $v.password.$error}">
			<PasswordField :name="'login_password'" v-model="password" />
			<FormError :error="$v.password.$error" :message="passwordError" />
		</div>

		<!-- Forgot password -->
		<!-- <a role="button" class="link type--sans type--s" @click="$emit('forgot-password')" >Forgot Password?</a> -->
	</div>
</template>

<script>
import PasswordField from "@/components/formfields/FlytPasswordField"
import FormInput from "@/components/formfields/FormInput"
import FormError from "@/components/formfields/FormError"
import { required, email } from "vuelidate/lib/validators"

export default {
	name: "LogInForm",

	data() {
		return {
			email: "",
			password: "",
			userNotFoundMessage: "Try again. Incorrect email and password combination.",
		}
	},

	components: { PasswordField, FormInput, FormError },

	props: {
		userNotFound: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		emailError() {
			let errorMessage = "Invalid input"
			if (!this.$v.email.required) errorMessage = "Please enter your email address"
			if (!this.$v.email.email) errorMessage = "Must be a valid email address"
			return errorMessage
		},

		passwordError() {
			let errorMessage = "Invalid input"
			if (!this.$v.password.required) errorMessage = "Please enter your password"
			return errorMessage
		},
	},

	validations: {
		email: { email, required },
		password: { required },
	},
}
</script>

<style lang="scss" scoped>
.error-message {
	margin-bottom: 1.5rem;
}
</style>
